import React, { useContext, useState, useEffect } from 'react'
import { ASBox, ASGBoxscoreCon } from '../../styles'
import { AllStarContext } from '../../../../Context'
import { EventBox } from '../../../../Components/GameTicker/EventBox/EventBox'

export const AllStarBoxscore: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { loading, allStarEvent } = useContext(AllStarContext)!
  const [showBoxscore, setShowBoxscore] = useState<boolean>(false)

  useEffect(() => {
    if (allStarEvent && allStarEvent?.eventStatus >= 0) {
      setShowBoxscore(true)
    }
  }, [allStarEvent])

  return (
    <ASGBoxscoreCon>
      <ASBox>
        {!loading && showBoxscore && allStarEvent && (
          <EventBox eventData={allStarEvent} />
        )}
      </ASBox>
    </ASGBoxscoreCon>
  )
}
